import { Button, Input } from '@hub-la/shadcn'
import debounce from 'lodash/debounce'
import { Download, Search } from 'lucide-react'
import React from 'react'
import { useTranslation } from 'react-i18next'

type ActionsProps = {
  onSearchChange: (value: string) => void
  onExportDeactivateMembers: () => void
}

export const Actions: React.FC<ActionsProps> = ({ onSearchChange, onExportDeactivateMembers }) => {
  const { t } = useTranslation()

  const handleSearchChange = debounce((value: string) => onSearchChange(value), 500)

  return (
    <div className="flex flex-col space-y-4 md:flex-row md:justify-between md:items-center md:space-y-0">
      <div className="flex flex-col space-y-4 md:flex-row md:space-y-0 md:space-x-2 w-full md:w-auto">
        <div className="relative w-full md:w-[350px]">
          <Search className="absolute w-4 h-4 right-3 top-1/2 transform -translate-y-1/2 text-muted-foreground z-10" />
          <Input
            id="search"
            className="w-full"
            placeholder={t('tabs.oldMembers.actions.search.placeholder')}
            onChange={(e) => handleSearchChange(e.target.value)}
          />
        </div>
      </div>
      <Button variant="outline" onClick={onExportDeactivateMembers} className="w-full sm:w-auto">
        <Download className="mr-2 h-4 w-4" />
        {t('tabs.oldMembers.actions.export')}
      </Button>
    </div>
  )
}
